import React from "react";
import "./style.css";
import { Paper, Stack } from "@mui/material";
import useDebugInformation from "../../../../../../../hooks/useDebugInformation";
import { ui } from "../../../../../../../interfaces/interfaces";
import AddressTab from "../../../../../../Shared/AddressTab";
import AppointmentTabHeader from "../../../../../../Shared/AppointmentTabHeader";
import BusinessSwitch from "../../../../../../Shared/BusinessSwitch";
import ContactTab from "../../../../../../Shared/ContactTab";
import CustomerSwitch from "../../../../../../Shared/CustomerSwitch";
import { addAddress, removeAddress } from "./helpers";
import { useAppSelector } from "@store/hooks";
import { AddressPrefix, ContactPrefix } from "@utils/BasicTypes";
import SwipeableViews from "@arzymski/react-swipeable-views";

const name = "Tabs";

const handleChangeIndex = (index: number) => {
  ui.ProblemActiveAddressTab = index
};

type AddressTabProps = {
  parent: string
  affix: "Contact" | "Address"
}

const Tabs: React.FC<AddressTabProps> = ({ parent, affix }) => {
  const problemActiveTab = useAppSelector(({ ui }) => ui[`ProblemActive${affix}Tab`])
  const problemTabsList = useAppSelector(({ ui }) => ui.ProblemTabsList)

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { problemActiveTab, problemTabsList })
  return (
    <Stack sx={{
      backgroundColor: (theme) => theme.palette.background.paper,
      width: "100%",
      position: "relative",
      minHeight: 160,
    }}>
      <AppointmentTabHeader parent={parent} affix={affix} />
      <SwipeableViews
        axis="x"
        index={problemActiveTab}
        onChangeIndex={handleChangeIndex}
        slideStyle={{ paddingInline: "4px" }}
        style={{ width: "calc(100% + 8px)", marginLeft: -4 }}
      >
        {JSON.parse(problemTabsList).filter((t: { name: string; }) => ((t.name === "property" && affix === "Address") || affix === "Contact")).map((tab: { label: string; name: string }, idx: number) => (
          <Paper key={`${idx}_Tab_${affix}`} sx={(theme) => ({
            mt: 1, mb: 1, p: 1, pb: 2, pt: 2,
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
              mt: 1, mb: 1, p: 1, pb: 2, pt: 2,
            },
          })}
            elevation={4} >
            <form noValidate >
              {affix === "Address" ? (<AddressTab parent={debugName} prefix={`${tab.label}${affix}` as AddressPrefix} >
                <BusinessSwitch parent={debugName} prefix={`${tab.label}${affix}` as AddressPrefix} />
              </AddressTab>)
                : (
                  <ContactTab parent={debugName} prefix={`${tab.label}${affix}` as ContactPrefix} min={false} related={`${tab.label}${affix}` === "RelatedContact"}>
                    <CustomerSwitch addAddress={addAddress} removeAddress={removeAddress} prefix={`${tab.label}${affix}` as "PropertyContact"} />
                  </ContactTab>)}
            </form>
          </Paper>
        )
        )}
      </SwipeableViews>
    </Stack>)
}

Tabs.displayName = name;


export default React.memo(Tabs)